import { type DependencyList, useEffect } from 'react';
import type { Subscription } from 'rxjs';

const useSubscriptions = (
  subscriptionsHandlers: () => Subscription[],
  deps?: DependencyList,
) => {
  useEffect(() => {
    const subscriptions = subscriptionsHandlers();
    return () => subscriptions.forEach(sub => sub.unsubscribe());
  }, deps ?? []);
};

export default useSubscriptions;
